import { useEffect, useState } from "react";
import { CheckCircle2, Circle, Rocket } from "lucide-react";
import { api } from "@/lib/api";
import { Panel, Spinner, Tag } from "@/components/common";

export const GoLiveChecklist = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/go-live/checklist").then((r) => setData(r.data)); }, []);
  return (
    <Panel title="Go-live checklist" icon={Rocket} testid="go-live-checklist"
      right={data && <Tag tone={data.ready ? "emerald" : "amber"} testid="go-live-status">{data.ready ? "Ready to go live" : "Not ready"}</Tag>}>
      {!data ? <Spinner /> : (
        <ol className="space-y-4">
          {data.items.map((i, n) => (
            <li key={i.key} data-testid={`go-live-item-${i.key}`} className="flex gap-3">
              {i.done ? <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-400" /> : <Circle className="mt-0.5 h-5 w-5 shrink-0 text-slate-600" />}
              <div>
                <div className={`text-sm font-semibold ${i.done ? "text-slate-200" : "text-slate-300"}`}>{n + 1}. {i.label}</div>
                <div className="mt-0.5 break-all font-mono text-xs text-slate-500">{i.detail}</div>
              </div>
            </li>
          ))}
        </ol>
      )}
    </Panel>
  );
};
